var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.$t("settings.users.userEdit")))]),
    _c(
      "div",
      { staticClass: "mt-3 elevation-12 grey lighten-4" },
      [
        _c("user-settings-menu"),
        _c(
          "v-card",
          [
            _c(
              "v-card-text",
              [
                _c(
                  "v-alert",
                  { attrs: { type: "info" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("settings.users.costCentre.alert.text")) +
                        " "
                    ),
                    _c(
                      "router-link",
                      {
                        staticClass: "text--secondary",
                        attrs: { to: "/settings/cost-centre" }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("settings.users.costCentre.alert.href")
                            ) +
                            "."
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "v-form",
                  {
                    ref: "form",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.formValid,
                      callback: function($$v) {
                        _vm.formValid = $$v
                      },
                      expression: "formValid"
                    }
                  },
                  [
                    _c("h2", [
                      _vm._v(_vm._s(_vm.$t("settings.users.costCentre.title")))
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("settings.users.costCentre.description")
                        ) +
                        " "
                    ),
                    _c("v-data-table", {
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.allCostCentres,
                        search: _vm.search,
                        "show-select": "",
                        "disable-sort": "",
                        sor: ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "item",
                          fn: function(props) {
                            return [
                              _c("tr", [
                                _c(
                                  "td",
                                  [
                                    _c("v-checkbox", {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        "hide-details": "",
                                        primary: ""
                                      },
                                      on: { change: props.select },
                                      model: {
                                        value: props.isSelected,
                                        callback: function($$v) {
                                          _vm.$set(props, "isSelected", $$v)
                                        },
                                        expression: "props.isSelected"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("td", { staticClass: "text-left" }, [
                                  _vm._v(_vm._s(props.item.list_order))
                                ]),
                                _c("td", { staticClass: "text-left" }, [
                                  _vm._v(_vm._s(props.item.name))
                                ])
                              ])
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.currentCostCentres,
                        callback: function($$v) {
                          _vm.currentCostCentres = $$v
                        },
                        expression: "currentCostCentres"
                      }
                    }),
                    _c("v-select", {
                      attrs: {
                        items: _vm.currentCostCentres,
                        label: _vm.$t(
                          "settings.users.costCentre.defaultCostCentre"
                        ),
                        clearable: "",
                        "item-text": "name",
                        "item-value": "id"
                      },
                      model: {
                        value: _vm.defaultCostCentre,
                        callback: function($$v) {
                          _vm.defaultCostCentre = $$v
                        },
                        expression: "defaultCostCentre"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-card",
          [
            _c(
              "v-card-actions",
              [
                _c("v-spacer"),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "blue darken-1", text: "" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      disabled:
                        !_vm.formValid || _vm.$store.getters["Ajax/loading"],
                      color: "blue darken-1",
                      text: ""
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.save()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.save")) + " ")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }